export default "__VITE_ASSET__CjCI5z6V__"